
import Form from "./Form.vue";
import PessoaData from "./PessoaData";
import { mapGetters } from "vuex";

export default {
  name: "app-contador-create",
  data() {
    return {
      pessoa: new PessoaData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
